export function getTaxDisplayName(taxType) {
  switch (taxType) {
    case 'sales_tax':
      return 'Sales tax';
    case 'vat':
      return 'VAT';
    case 'gst':
      return 'GST';
    case 'hst':
      return 'HST';
    case 'pst':
      return 'PST';
    case 'qst':
      return 'QST';
    case 'rst':
      return 'RST';
    case 'jct':
      return 'JCT';
    case 'igst':
      return 'IGST';
    case 'lease_tax':
      return 'Lease tax';
    case 'communications_tax':
      return 'Communications tax';
    case 'amusement_tax':
      return 'Amusement tax';
    default:
      return 'Tax';
  }
}
